var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Search/24"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 11,
    cy: 11,
    r: 7,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M17.7678 16.2929L17.0607 15.5858L15.6465 17L16.3536 17.7071L17.7678 16.2929ZM19.182 20.5355C19.5725 20.9261 20.2057 20.9261 20.5962 20.5355C20.9867 20.145 20.9867 19.5118 20.5962 19.1213L19.182 20.5355ZM16.3536 17.7071L19.182 20.5355L20.5962 19.1213L17.7678 16.2929L16.3536 17.7071Z",
    fill: "currentColor"
  }))));
};
export default SvgMagnifyingGlass;